import React from 'react';
import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';
import type { TaskPriority } from '../../types/tasks';

interface PriorityBadgeProps {
  priority: TaskPriority;
  className?: string;
}

const priorityConfig: Record<TaskPriority, { label: string; className: string }> = {
  Low: {
    label: 'Low',
    className: 'border-transparent bg-slate-100 text-slate-700 dark:bg-slate-800/30 dark:text-slate-400',
  },
  Medium: {
    label: 'Medium',
    className: 'border-transparent bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  },
  High: {
    label: 'High',
    className: 'border-transparent bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400',
  },
  Urgent: {
    label: 'Urgent',
    className: 'border-transparent bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
};

const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, className }) => {
  const config = priorityConfig[priority];
  return (
    <Badge className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
};

export default PriorityBadge;
